<template>
  <div class="label-options-config-dialog">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item
        v-if="!editingCondition"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="状态设置"
        name="1"
      >
        <div class="content">
          <div>
            <div
              v-for="(conditionItem, index) in conditionList"
              :key="index"
              class="content-item mb8 conditionListContent"
            >
              <el-tooltip
                :content="conditionItem.value ? `文本内容为“${conditionItem.value}”时` : `文本内容为空时`"
                placement="left"
              >
                <div class="text">
                  {{
                    conditionItem.value
                      ? `文本内容为“${
                          conditionItem.value.length > 3 ? conditionItem.value.slice(0, 3) + "..." : conditionItem.value
                        }”时`
                      : `文本内容为空时`
                  }}
                </div>
              </el-tooltip>
              <div class="content-btns">
                <div class="content-btn" @click="changeLabelStyle(index)">
                  <span class="icon-portal-edit-1"></span>
                </div>
                <div class="content-btn" @click="deleteCondition(index)">
                  <span class="icon-portal-delete1"></span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="conditionList.length < 20" class="addConditionBtn" @click="addCondition">
            <span class="icon-portal-plus mr2"></span>
            <span class="">添加状态</span>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div v-if="editingCondition" class="label_edit">
      <div class="label_edit_title">
        <span class="setting_label">状态设置</span>
        <div>
          <el-button size="mini" class="cancel_btn" @click="onCancelCondition">取消</el-button>
          <el-button size="mini" type="primary" @click="onSaveCondition">保存</el-button>
        </div>
      </div>
      <div class="content">
        <div class="condition_value_title mb8">触发条件</div>
        <div class="content-item fs14 verticallyCenter">
          <span class="mr8">文本内容为</span>
          <el-input
            class="size-inp mr8"
            style="width: 126px; height: 32px"
            v-model="conditionValue"
            placeholder="请输入"
            maxLength="40"
          />
          <span>时</span>
        </div>
      </div>
      <div class="spliter"></div>
      <div class="content">
        <div class="content-item fs14 verticallyCenter mb12">
          <span class="mr16">显示文本</span>
          <el-input style="width: 156px; height: 32px" v-model="conditionResult" placeholder="请输入" maxLength="40" />
        </div>
        <div class="verticallyCenter mb12">
          <span class="fs14 mr16">文本颜色</span>
          <cx-color-picker
            style="width: 156px"
            :isThemeColor.sync="textIsThemeColor"
            :colorArr.sync="colorArr"
            :activeName.sync="activeNameColor"
            :showSecondTab="true"
          />
        </div>
        <div class="verticallyCenter mb12">
          <span class="fs14 mr16">边框颜色</span>
          <cx-color-picker style="width: 156px" :isThemeColor.sync="textIsThemeColor" :colorArr.sync="borderColor" />
        </div>
        <cx-background :background.sync="background" imgType="10" class="mt16 mb12" :options="editingOptions" />
        <div class="mb8">图标</div>
        <img-icon-upload
          class="mb16"
          :imgSrc.sync="iconSrc"
          :iconType.sync="iconType"
          :iconColor.sync="iconColor"
          :resInfo.sync="resInfo"
        />
        <div class="verticallyCenter mb16">
          <span class="mr16 fs14">图标颜色</span>
          <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import silderAndInput from "modules/components/sliderAndInput.vue"
import { simpleDeepClone } from "utils"
export default {
  name: "label-options-config",
  components: { widthAndSizeAndZindex },
  props: {
    options: Object,
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      collapseActiveNames: ["1"],
      activeNames: ["1"],
      editingCondition: false,
      editingIndex: 0,
      lastConditionOptions: {},
      // 新增
      newAdd: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    content: {
      get() {
        let content = this.options.content?.replace(/(<br>)*$/g, "") //替换末尾换行符
        return content
      },
      set(newVal) {
        newVal = String(newVal).replace(/<[^>]+>/g, "<br>")
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
    conditionList() {
      return this.options.conditionList || []
    },
    editingOptions() {
      return this.conditionList[this.editingIndex].options
    },
    conditionValue: {
      get() {
        return this.conditionList[this.editingIndex].value
      },
      set(newVal) {
        this.conditionList[this.editingIndex].value = newVal
      }
    },
    conditionResult: {
      get() {
        return this.conditionList[this.editingIndex].result
      },
      set(newVal) {
        this.conditionList[this.editingIndex].result = newVal
      }
    },
    textIsThemeColor: {
      get() {
        return this.editingOptions.textIsThemeColor
      },
      set(newVal) {
        this.editingOptions.textIsThemeColor = newVal
      }
    },
    borderIsThemeColor: {
      get() {
        return this.editingOptions.borderIsThemeColor
      },
      set(newVal) {
        this.editingOptions.borderIsThemeColor = newVal
      }
    },
    colorArr: {
      get() {
        return this.editingOptions.colorArr
      },
      set(newVal) {
        this.editingOptions.colorArr = newVal
      }
    },
    activeNameColor: {
      get() {
        return this.editingOptions.activeNameColor
      },
      set(newVal) {
        this.editingOptions.activeNameColor = newVal
      }
    },
    borderColor: {
      get() {
        return this.editingOptions.borderColor
      },
      set(newVal) {
        this.editingOptions.borderColor = newVal
      }
    },
    background: {
      get() {
        return this.editingOptions.background
      },
      set(newVal) {
        this.editingOptions.background = newVal
      }
    },
    iconSrc: {
      get() {
        return this.editingOptions.iconSrc
      },
      set(newVal) {
        this.editingOptions.iconSrc = newVal
      }
    },
    iconType: {
      get() {
        return this.editingOptions.iconType
      },
      set(newVal) {
        this.editingOptions.iconType = newVal
      }
    },
    iconColor: {
      get() {
        return this.editingOptions.iconColor
      },
      set(newVal) {
        this.editingOptions.iconColor = newVal
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.editingOptions, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.editingOptions.resInfo = newVal
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.editingOptions.iconColorIsThemeColor
      },
      set(newVal) {
        this.editingOptions.iconColorIsThemeColor = newVal
      }
    }
  },
  methods: {
    // 添加条件
    addCondition() {
      this.newAdd = true
      // 改变的样式和内容
      const condition = {
        value: "",
        result: "",
        options: {
          textIsThemeColor: false,
          activeNameColor: "first",
          colorArr: {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            data: {
              angle: 0,
              stops: [
                [this.options.color, 0],
                [this.options.color, 1]
              ]
            }
          },
          borderIsThemeColor: false,
          borderColor: {
            type: "color",
            label: "颜色",
            color: this.options.bgColor
          },
          bgColorIsThemeColor: false,
          background: [
            {
              type: "color",
              label: "颜色",
              isThemeColor: true,
              color: this.options.bgColor
            }
          ],
          iconSrc: this.options.iconSrc,
          iconType: this.options.iconType,
          iconColor: this.options.iconColor,
          resInfo: {},
          iconColorIsThemeColor: false
        }
      }
      this.conditionList.push(condition)
      this.$changeOptionsEV(this.conditionList, "conditionList", false)
      this.editingIndex = this.conditionList.length - 1
      this.editingCondition = true
    },
    // 删除条件
    deleteCondition(index) {
      this.conditionList.splice(index, 1)
      this.$changeOptionsEV(this.conditionList, "conditionList", false)
    },
    // 取消保存条件
    onCancelCondition() {
      if (this.newAdd) {
        this.conditionList.splice(this.editingIndex, 1)
      } else {
        this.conditionList[this.editingIndex] = this.lastConditionOptions
        this.$changeOptionsEV(this.conditionList, "conditionList", false)
      }
      this.editingCondition = false
      this.newAdd = false
    },
    // 保存条件
    onSaveCondition() {
      const result = this.conditionList.find(
        (item, index) => item.value === this.conditionValue && index !== this.editingIndex
      )
      if (result) {
        this.$message.error("已有相同条件，请修改后保存")
      } else {
        this.editingCondition = false
        this.newAdd = false
      }
    },
    // 改变条件的样式设置
    changeLabelStyle(index) {
      this.editingIndex = index
      this.lastConditionOptions = simpleDeepClone(this.conditionList[index])
      this.editingCondition = true
    }
  },
  beforeDestroy() {
    if (this.editingCondition) {
      //this.onCancelCondition()
    }
  }
}
</script>

<style lang="scss" scoped>
.bigScreen-toolbar {
  .conditionListContent {
    background-color: #35383f;
    border-color: #373737;
    .content-btns {
      .content-btn {
        color: rgba(255, 255, 255, 0.4);
        &:hover {
          background-color: rgba(255, 255, 255, 0.08);
        }
      }
    }
  }
  .label_edit {
    .label_edit_title {
      background-color: #282a2e;
      .cancel_btn {
        color: rgba(255, 255, 255, 0.8);
        border-color: rgba(255, 255, 255, 0.3);
      }
    }
  }
}
.conditionListContent {
  display: flex;
  height: 32px;
  border: 1px solid #e9e9e9;
  background-color: #f3f3f3;
  border-radius: 4px;
  padding: 4px 8px;
  justify-content: space-between;
  align-items: center;
  .text {
    width: 160px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    font-weight: 400;
  }
  .content-btns {
    display: flex;
    width: 48px;
    height: 24px;
    .content-btn {
      width: 50%;
      padding: 2px 5px;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
      }
    }
  }
}
.addConditionBtn {
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  height: 32px;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.label_edit {
  .label_edit_title {
    height: 44px;
    background: #f0f0f0;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .setting_label {
      font-weight: 600;
    }
    ::v-deep .el-button--mini {
      height: 28px;
      width: 50px;
      padding: 7px 13px;
    }
    .cancel_btn {
      color: rgba(0, 0, 0, 0.8);
      border-color: rgba(0, 0, 0, 0.14);
      background-color: rgba(0, 0, 0, 0);
      &:hover {
        color: var(--themeColor);
        border-color: var(--themeColor);
      }
    }
  }
  .content {
    padding: 12px 16px;
    .condition_value_title {
      font-weight: bold;
    }
  }
  .spliter {
    border-bottom: 1px solid rgba(233, 233, 233, 1);
  }
}
</style>
